//menu-item-has-children
document.addEventListener('DOMContentLoaded', () => {
  const mobileMenu = document.getElementById('menu-mobile-menu');
  if (mobileMenu) {
    const menuItems = mobileMenu.querySelectorAll('.menu-item-has-children');

    [...menuItems].forEach((menu) => {
      const btn = document.createElement('button');
      btn.innerHTML = '<span></span><span></span>';
      menu.appendChild(btn);

      btn.addEventListener('click', () => {
        menu.classList.toggle('show-sub-menu');
      });
    });
  }

  function getOffset(el) {
    var _x = 0;
    var _y = 0;
    while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
      _x += el.offsetLeft - el.scrollLeft;
      _y += el.offsetTop - el.scrollTop;
      el = el.offsetParent;
    }
    return { top: _y, left: _x };
  }
  let clickedCountryNode, clickedCountryEventId;
  const countrySelector = document.getElementById('country-selector');
  const countrySelectorTriggers = document.querySelectorAll(
    '.select-another-location'
  );
  if (countrySelector && countrySelectorTriggers) {
    countrySelectorTriggers.forEach(function (node) {
      node.addEventListener('click', function (e) {
        e.stopPropagation();
        node.blur();
        clickedCountryNode = node;
        clickedCountryEventId = e.target.id;
        positionCountrySelector(
          clickedCountryNode,
          countrySelector,
          clickedCountryEventId
        );
        countrySelector.style.display = 'block';
      });
    });

    document.addEventListener('scroll', function () {
      if (
        clickedCountryNode &&
        clickedCountryNode.id !== 'country-selector-trigger'
      ) {
        positionCountrySelector(clickedCountryNode, countrySelector, '');
      }
    });

    function positionCountrySelector(node, countrySelector, id) {
      var o = getOffset(node);
      var scrollTop =
        window.pageYOffset !== undefined
          ? window.pageYOffset
          : (
              document.documentElement ||
              document.body.parentNode ||
              document.body
            ).scrollTop;

      var t = o.top + 24;
      var l = o.left;

      if (id !== 'country-selector-trigger') {
        t = t - scrollTop;
      }
      if (id === 'country-selector-trigger') {
        var elemRect = node.getBoundingClientRect();
        l = l - elemRect.width - 40;
        if (document.body.classList.contains('admin-bar')) t = t - 32;
      }

      if (document.body.classList.contains('admin-bar')) {
        if (t < 86) countrySelector.style.display = 'none';
      } else {
        if (t < 54) countrySelector.style.display = 'none';
      }

      countrySelector.style.top = t + 'px';
      countrySelector.style.left = l + 'px';
    }

    countrySelector.addEventListener('click', function (e) {
      if (e.target.type == 'radio') {
        window.location = e.target.value;
      }
    });

    document.addEventListener('click', function () {
      countrySelector.style.display = 'none';
    });
  }
});
